var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "193px",
    viewBox: "0 0 256 193",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DD3835"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2594273,192.231662 L93.1619166,192.231662 L102.705332,159.511379 L150.422412,159.511379 L159.965828,192.231662 L192.68611,192.231662 L128.154442,0 L62.2594273,192.231662 L62.2594273,192.231662 Z M128.154442,83.6185008 L144.514583,136.334512 L111.7943,136.334512 L128.154442,83.6185008 L128.154442,83.6185008 Z M255.854434,154.512447 L252.673296,141.333444 L185.414936,134.516719 L194.049456,157.693586 L255.854434,154.512447 L255.854434,154.512447 Z M70.439498,136.334512 L3.18113862,143.151238 L0,156.330241 L62.2594273,159.511379 L70.439498,136.334512 L70.439498,136.334512 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApx);
export default __webpack_public_path__ + "static/media/apx.0c0793fdf166806dd0865ae1e1b6921b.svg";
export { ForwardRef as ReactComponent };